module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-body-wrap",
    attrs: {
      "id": "app"
    }
  }, [_c('main', {
    staticClass: "c-main",
    attrs: {
      "id": "main",
      "role": "main"
    }
  }, [(_vm.view == 'default') ? _c('home') : _vm._e(), _vm._v(" "), (_vm.view == 'riddles') ? _c('game') : _vm._e(), _vm._v(" "), _c('promotions')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a8455a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/AppMain.vue
// module id = 66
// module chunks = 0